// frontend/src/store/slices/profilesSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profiles: [],
  currentProfile: null,
  loading: false,
  error: null,
};

const profilesSlice = createSlice({
  name: "profiles",
  initialState,
  reducers: {
    setProfiles: (state, action) => {
      state.profiles = action.payload;
      // If there's a stored profile ID, set the current profile
      const savedProfileId = localStorage.getItem("currentProfile");
      if (savedProfileId) {
        state.currentProfile =
          state.profiles.find((p) => p.id === savedProfileId) || null;
      }
    },
    setCurrentProfile: (state, action) => {
      state.currentProfile =
        state.profiles.find((p) => p.id === action.payload) || null;
    },
    addProfile: (state, action) => {
      state.profiles.push(action.payload);
    },
    updateProfile: (state, action) => {
      const index = state.profiles.findIndex((p) => p.id === action.payload.id);
      if (index !== -1) {
        state.profiles[index] = action.payload;
      }
    },
    deleteProfile: (state, action) => {
      state.profiles = state.profiles.filter((p) => p.id !== action.payload);
      if (state.currentProfile?.id === action.payload) {
        state.currentProfile = null;
      }
    },
  },
});

export const {
  setProfiles,
  setCurrentProfile,
  addProfile,
  updateProfile,
  deleteProfile,
} = profilesSlice.actions;

export default profilesSlice.reducer;
